import styled from "styled-components";

export const PageContent = styled.div`
  padding: 24px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h3 {
    font-family: "Poppins";
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
`;

export const BannersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

/* ---------- Card ---------- */
export const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 16px;
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.08),
    0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const CardThumb = styled.div`
  flex-shrink: 0;
  width: 84px;
  height: 84px;
  border-radius: 8px;
  border: 1px solid #eee;
  background: #f6f6f6;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CardTitle = styled.span`
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const CardInfo = styled.span`
  font-family: "Poppins";
  font-size: 12px;
  color: #6c6c6c;
`;

export const BadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
`;

export const Badge = styled.span`
  font-family: "Poppins";
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: ${({ color }) => color || "#6c757d"};
`;

export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

/* ---------- Form ---------- */
export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldLabel = styled.span`
  font-family: "Poppins";
  font-size: 13px;
  font-weight: 500;
  color: #222;
  margin-bottom: 6px;
  display: block;
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 10px;
  font-family: "Poppins";
  font-size: 14px;
  color: #333;
  background: #fff;
  outline: none;

  &:focus {
    border-color: #007bff;
  }
`;

export const CheckRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Poppins";
  font-size: 14px;
  color: #333;
  cursor: pointer;
  margin: 0;
`;

export const SystemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ErrorText = styled.span`
  color: #c8131b;
  font-size: 12px;
  font-family: "Poppins";
`;

export const HintText = styled.span`
  font-family: "Poppins";
  font-size: 11px;
  color: #999;
  display: block;
  margin-top: 2px;
`;

export const ImagePicker = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #ddd;
  }

  label {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    height: 120px;
    padding: 0 12px;
    border-radius: 8px;
    border: 2px dashed #ddd;
    color: #999;
    font-family: "Poppins";
    font-size: 12px;
    text-align: center;

    &:hover {
      border-color: #007bff;
    }
  }

  input[type="file"] {
    display: none;
  }
`;

/* ---------- Buttons builder ---------- */
export const Section = styled.div`
  border-top: 1px solid #ededed;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
`;

export const ButtonRowCard = styled.div`
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SmallGhostButton = styled.button`
  background: none;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 6px 12px;
  font-family: "Poppins";
  font-size: 13px;
  color: #333;
  cursor: pointer;

  &:hover {
    background: #f6f6f6;
  }
`;

export const RemoveButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #6c6c6c;
  cursor: pointer;

  &:hover {
    background: #fdecec;
    color: #c8131b;
    border-color: #f3c2c2;
  }
`;

/* ---------- Preview ---------- */
export const PreviewWrap = styled.div`
  position: sticky;
  top: 8px;
`;

export const PreviewStage = styled.div`
  background: rgba(40, 44, 52, 0.85);
  border-radius: 10px;
  padding: 18px;
  display: flex;
  justify-content: center;
`;

export const ModalMock = styled.div`
  width: 100%;
  max-width: 340px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
`;

export const ModalMockHeader = styled.div`
  background: ${({ color }) => color || "#FF2C3A"};
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  span.logo {
    color: #fff;
    font-family: "Poppins";
    font-weight: 700;
    letter-spacing: 0.3px;
  }

  span.close {
    position: absolute;
    right: 12px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
  }
`;

export const ModalMockImage = styled.div`
  background: repeating-conic-gradient(#f1f5f9 0% 25%, #fff 0% 50%) 0 0 / 18px
    18px;

  img {
    width: 100%;
    display: block;
    cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  }
`;

export const ModalMockPlaceholder = styled.div`
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-family: "Poppins";
  font-size: 13px;
`;

export const ModalMockFooter = styled.div`
  display: flex;
  flex-direction: ${({ $row }) => ($row ? "row" : "column")};
  justify-content: space-between;
  gap: 8px;
  padding: 14px;
`;

export const PreviewButton = styled.button`
  ${({ $row }) => ($row ? "flex: 1;" : "width: 100%;")}
  border-radius: 8px;
  padding: 10px 14px;
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: ${({ variant }) => (variant === "secondary" ? "#FF2C3A" : "none")};
  background: ${({ variant, color }) =>
    variant === "secondary" ? "#fff" : color || "#FF2C3A"};
  color: ${({ variant }) => (variant === "secondary" ? "#FF2C3A" : "#fff")};
`;

export const CenterMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px;
  font-family: "Poppins";
  color: #6c6c6c;
`;

/* ---------- Lista de imagens (carrossel) ---------- */
export const ImageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ImageItem = styled.div`
  display: flex;
  gap: 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px;

  > img {
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #ddd;
    flex-shrink: 0;
  }
`;

export const ImageItemBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const ImageItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: "Poppins";
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }

  > div {
    display: flex;
    gap: 6px;
  }
`;

export const IconBtn = styled.button`
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #555;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f6f6f6;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const AddImageButton = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 2px dashed #ddd;
  color: #007bff;
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    border-color: #007bff;
  }
  input[type="file"] {
    display: none;
  }
`;

/* ---------- Carrossel no preview ---------- */
export const CarouselWrap = styled.div`
  position: relative;
`;

export const NavArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ side }) => (side === "left" ? "left: 8px;" : "right: 8px;")}
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.65);
  }
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
`;

export const Dot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: ${({ active }) => (active ? "#fff" : "rgba(255, 255, 255, 0.5)")};
`;
